import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { RouteConstants } from "../constants";
import { errorState, userCurrencyState, authState } from "../states";

export const useHandleError = () => {
    const setError = useSetRecoilState(errorState);
    const setUserCurrency = useSetRecoilState(userCurrencyState);
    const setAuth = useSetRecoilState(authState);
    const navigate = useNavigate();

    const getErrorMsg = (error: any, errorType?: any) => {
        const type = errorType !== undefined && errorType !== null ? errorType : 'Error';
        const detail = error?.response?.data?.detail;
        const tokenErrors = [
            'authentication credentials were not provided.',
            'invalid refresh token',
        ];

        if (detail) {
            if (detail?.toLowerCase() === 'user not found') {
                localStorage.removeItem('user');
                localStorage.removeItem('email_id');
                localStorage.removeItem('currency');
                localStorage.removeItem('selCategoryList');
                setAuth({});
                setUserCurrency('');
            } else if (error?.response?.status === 400) {
                setError({ type, message: detail });
            } else if (error?.response?.status === 404) {
                navigate(RouteConstants.not_found);
            } else if (
                error?.response?.status === 401 
            ) {
                localStorage.clear()
                setAuth({});
                setUserCurrency('');
                navigate(RouteConstants.login);
            }
                else if (detail.includes('Something went wrong') || error?.response?.status === 500
            ) {
                navigate(RouteConstants.something_went_wrong);
            }
             else if (!tokenErrors.some((string) => detail?.toLowerCase().includes(string))) {
                setError({ type: 'Error', message: detail });
            } 
        } else {
            // Default behavior for undefined detail
            navigate(RouteConstants.something_went_wrong);
        }
    };
    return { getErrorMsg };
}